"use client";
import clsx from "clsx";
import React from "react";
export default function ArrowLink(param) {
    var text = param.text, target = param.target, className = param.className, reverse = param.reverse, external = param.external, newTab = param.newTab;
    var rotation = reverse ? "rotate-180 ml-0 mr-1" : null;
    return /*#__PURE__*/ React.createElement("a", {
        target: external || newTab ? "_blank" : "_self",
        rel: external || newTab ? "noreferrer" : "",
        href: "".concat(target),
        className: clsx("group inline-flex items-center text-sm font-heading font-semibold focus", className)
    }, /*#__PURE__*/ React.createElement("span", {
        className: "mr-1"
    }, !rotation && text), /*#__PURE__*/ React.createElement("svg", {
        width: "15px",
        height: "12px",
        viewBox: "0 0 15 12",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: "ml-1.5 relative text-black left-0 group-hover:left-1 group-hover:text-blue-500 transition-all ".concat(rotation)
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(-460.000000, -5707.000000)",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Case-Studies",
        transform: "translate(75.000000, 5059.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Industry/Featured",
        transform: "translate(0.000000, 284.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Link-Tab",
        transform: "translate(268.000000, 340.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Link/Learn/Static",
        transform: "translate(40.000000, 23.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Arrow/Small",
        transform: "translate(77.000000, 0.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8.51677215,2.05025253 L13.5057818,7 L8.51677215,11.9497475 M13.5057818,7 L0.805836652,7",
        id: "Icon"
    }))))))))), /*#__PURE__*/ React.createElement("span", {
        className: "ml-1"
    }, rotation && text));
}
